/* ═══════════════════════════════════════
   JIRO ARCHIVE — GLOBAL JS
   ═══════════════════════════════════════ */

(function(){

  /* ── Custom cursor ── */
  var c = document.getElementById('cursor');
  var r = document.getElementById('cursor-ring');
  if(c && r){
    var mx=0,my=0,rx=0,ry=0;
    document.addEventListener('mousemove',function(e){
      mx=e.clientX; my=e.clientY;
      c.style.left=mx+'px'; c.style.top=my+'px';
    });
    function animRing(){
      rx+=(mx-rx)*.12; ry+=(my-ry)*.12;
      r.style.left=rx+'px'; r.style.top=ry+'px';
      requestAnimationFrame(animRing);
    }
    animRing();
    document.querySelectorAll('a,button,.pcard,.cl-img-col').forEach(function(el){
      el.addEventListener('mouseenter',function(){ document.body.classList.add('cursor-hover'); });
      el.addEventListener('mouseleave',function(){ document.body.classList.remove('cursor-hover'); });
    });
  }

  /* ── Scroll reveal ── */
  var revealEls = document.querySelectorAll('.reveal');
  if(revealEls.length){
    if('IntersectionObserver' in window){
      var obs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){ e.target.classList.add('visible'); obs.unobserve(e.target); }
        });
      },{threshold:0, rootMargin:'0px 0px -10% 0px'});
      revealEls.forEach(function(el){ obs.observe(el); });
      // Safety net: if anything is still hidden shortly after load, reveal it.
      setTimeout(function(){
        revealEls.forEach(function(el){
          var r = el.getBoundingClientRect();
          if(r.top < window.innerHeight && r.bottom > 0){ el.classList.add('visible'); }
        });
      }, 600);
    } else {
      // No observer support — show everything.
      revealEls.forEach(function(el){ el.classList.add('visible'); });
    }
  }

  /* ── Rabbit runner ── */
  var brandMoment = document.getElementById('brandMoment');
  var rabbit = document.getElementById('rabbitRunner');
  if(brandMoment && rabbit){
    var fired=false;
    function runRabbit(){
      if(fired) return; fired=true;
      rabbit.style.transition='none'; rabbit.style.left='-260px';
      rabbit.getBoundingClientRect();
      rabbit.style.transition='left 8s linear'; rabbit.style.left='calc(100% + 260px)';
      setTimeout(function(){ fired=false; rabbit.style.transition='none'; rabbit.style.left='-260px'; },8500);
    }
    var rabbitObs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting) runRabbit(); });
    },{threshold:0.3});
    rabbitObs.observe(brandMoment);
  }

  /* ── Mobile nav ── */
  var ham = document.getElementById('hamburger');
  var mobileNav = document.getElementById('mobileNav');
  var mobileClose = document.getElementById('mobileNavClose');
  if(ham && mobileNav){
    ham.addEventListener('click',function(){ mobileNav.classList.add('open'); });
    if(mobileClose) mobileClose.addEventListener('click',function(){ mobileNav.classList.remove('open'); });
    mobileNav.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click',function(){ mobileNav.classList.remove('open'); });
    });
  }

  /* ── Drops dropdown ── */
  var dropsTrigger = document.getElementById('dropsTrigger');
  var dropsDropdown = document.getElementById('dropsDropdown');
  if(dropsTrigger && dropsDropdown){
    dropsTrigger.addEventListener('click',function(e){
      e.stopPropagation();
      dropsDropdown.classList.toggle('open');
    });
    document.addEventListener('click',function(){ dropsDropdown.classList.remove('open'); });
    dropsDropdown.addEventListener('click',function(e){ e.stopPropagation(); });
  }

  /* ── Newsletter ── */
  var nlForm = document.getElementById('nlForm');
  var nlSuccess = document.getElementById('nlSuccess');
  if(nlForm){
    nlForm.addEventListener('submit',function(e){
      e.preventDefault();
      nlForm.style.opacity='0'; nlForm.style.transform='translateY(-8px)';
      nlForm.style.transition='all .3s';
      setTimeout(function(){
        nlForm.style.display='none';
        if(nlSuccess){ nlSuccess.style.display='block'; }
      },300);
    });
  }

})();
